import { Control, Controller, useController } from 'react-hook-form'
import React from 'react'
import { t } from 'ttag'

import { FormData } from '../../ChallengeAdmin'
import YumSelect from '../../../../components/YumSelect/YumSelect'
import { CustomTypeCategory, customUnits } from '../../../../services/CustomTypes'
import { ReactComponent as UnitActiveIcon } from '../../../../assets/v3/icons/unit-active.svg'
import YumField from '../../../../components/YumInput/YumInput'
import { ProgressType } from '../../../../services/api.types'

interface ChallengePointsUnitFieldProps {
  control: Control<FormData, any>
  name: any
  category: CustomTypeCategory
  error: boolean
}

export default function ChallengePointsCustomUnitField(props: ChallengePointsUnitFieldProps) {
  const { control, name, category, error } = props
  const {
    field: { onChange, name: controllerName, value, ref },
  } = useController({
    control,
    name,
  })

  return (
    <Controller
      name={controllerName}
      rules={{
        required: true,
      }}
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          shrink
          label={t`Unit`}
          type="text"
          error={error}
          inputProps={{
            autoCapitalize: 'none',
            autoComplete: 'off',
          }}
          {...otherField}
        />
      )}
    />
  )
}
